module.exports = __webpack_public_path__ + "img/jb_zq4321.prt.6cb61089.jpg";